<script lang="ts">
  import { Router } from 'sly-svelte-location-router'
  import type { Routes } from 'sly-svelte-location-router'
  import Navigation from '@components/Navigation.svelte'

  const routes: Routes = {
    '/': '/design-system',
    '/design-system': {
      name: 'design-system',
      component: () => import('@pages/DesignSystemPage.svelte'),
    },
    '/logo': {
      name: 'logo',
      component: () => import('@pages/LogoPage.svelte'),
    },
    '/colors': {
      name: 'colors',
      component: () => import('@pages/ColorsPage.svelte'),
    },
    '/typography': {
      name: 'typography',
      component: () => import('@pages/TypographyPage.svelte'),
    },
    '/graphics': {
      name: 'graphics',
      component: () => import('@pages/GraphicsPage.svelte'),
    },
  }
</script>

<Navigation />

<main class="min-h-screen">
  <Router {routes}>
    <div class="flex items-center justify-center min-h-screen">
      <p class="font-body text-navy/40">Loading...</p>
    </div>
  </Router>
</main>
